import {FILESERVER} from '../constants'
import axiosInstance from "../utils/axios.interceptor";
export const getFileFromServer = (filename,filepath) => {
  return async (dispatch) => {
    let response = await axiosInstance({
      method: 'POST',
      url: '/readspecificfile',
      data: {"filename": filename,"filepath":filepath}
    });
    //This is to trigger componentWillReceiveProps()
    response.timestamp = new Date().toLocaleString();
    dispatch({type:FILESERVER,payload:response.data});
  };
};
